import { Controller } from "@hotwired/stimulus"

// Stamps the list a write was performed in onto that write's submission.
//
// Archiving a thread has to know which list the agent was looking at: whether the row stays (from
// the Spam list it does — Spam ignores state) and which thread follows it, so the pane can advance.
// A bare POST to /conversations/:id/archive carries none of that, and the list's own params are not
// in the address bar either — search, sort and the filter menu narrow it inside a Turbo Frame.
//
// Stamped at submit time rather than rendered as hidden fields because the forms are scattered
// across six partials and two of them are not inside the list at all: the snooze duration menu is
// parented to the body, and an undo button lives in a toast. Read from the DOM on each submit, so
// a re-rendered list is picked up without this controller reconnecting.
export default class extends Controller {
  stamp(event) {
    const form = event.target
    if (!form.matches?.("[data-list-action]")) return

    const body = event.detail.formSubmission?.body
    if (!body) return

    for (const [key, value] of Object.entries(this.listContext)) {
      body.set(`list[${key}]`, value)
    }

    if (this.openThreadId) body.set("list[open]", this.openThreadId)
  }

  get listContext() {
    const list = this.element.querySelector("[data-list-context]")
    if (!list) return {}

    return JSON.parse(list.dataset.listContext)
  }

  // Which thread the reader is actually looking at, which decides whether the pane has to move.
  // Read off the pane itself rather than from ?open, because the address bar disagrees with the pane
  // in both directions: a /conversations/:id deep link never writes ?open, and a tab link advances
  // it away while the pane keeps its thread. The pane cannot be wrong about what it is rendering.
  get openThreadId() {
    return this.element.querySelector(".thread[data-thread-id]")?.dataset.threadId
  }
}
